(function () {
    'use strict';

    angular.module("imApp").factory("bspSetupService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3334,
                    parameters: parms || {}
                });
            },
            listBsps: function (parms) {
                return $ihttp.post({
                    method: 3333,
                    parameters: parms || {}
                });
            },
            executeObj: function (edit) {
                return $ihttp.post({
                    method: 3335,
                    parameters: edit
                });
            },
            rollbackItem: function (edit) {
                return $ihttp.post({
                    method: 3336,
                    parameters: edit
                });
            },
            resetItem: function (edit) {
                return $ihttp.post({
                    method: 3584,
                    parameters: edit || {}
                });
            },
            nullDataItem: function (edit) {
                return $ihttp.post({
                    method: 3585,
                    parameters: edit || {}
                });
            },
            resetTransactionData: function (edit) {
                return $ihttp.post({
                    method: 3893,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
